import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("bk_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("bk_token");
        setUser(false);
      })
      .finally(() => setReady(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loginWith = (token, userData) => {
    localStorage.setItem("bk_token", token);
    setUser(userData);
  };

  const updateUser = (patch) => setUser((u) => ({ ...u, ...patch }));

  const refreshUser = () => api.get("/auth/me").then((res) => setUser(res.data)).catch(() => {});

  const logout = () => {
    localStorage.removeItem("bk_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, loginWith, logout, updateUser, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
